import { AsyncPipe, NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormsModule, NgControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IconsService } from '@davesa/components/icon-picker/icons.service';
import { Icon } from '@davesa/components/icon-picker/icons.types';
import {
    BehaviorSubject,
    Observable,
    Subject,
    combineLatest,
    map,
    switchMap,
    take,
    takeUntil,
} from 'rxjs';
import { DavesaLoadingBarComponent } from '../loading-bar';
import { DavesaLoadingService } from '@davesa/services/loading';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'icon-picker',
    templateUrl: './icon-picker.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        MatIconModule,
        MatFormFieldModule,
        MatDividerModule,
        MatInputModule,
        MatSelectModule,
        FormsModule,
        MatOptionModule,
        MatMenuModule,
        MatTooltipModule,
        MatButtonModule,
        MatSelectModule,
        MatOptionModule,
        NgClass,
        AsyncPipe,
        FormsModule,
        ReactiveFormsModule,
        DavesaLoadingBarComponent,
    ],
    providers: [IconsService]
})
export class IconPickerComponent implements OnInit, OnDestroy {
    @Input() iconSize: string = 'icon-size-16';
    @Input() selectedIcon: any = ['davesa', 'davesa-c'];  
    @Output() iconPickerSelect:EventEmitter<any> = new EventEmitter<any>(true);
    
    _davesaLoadingService = inject(DavesaLoadingService);
    private _icons: BehaviorSubject<Icon> = new BehaviorSubject(null);
    get icons$(): Observable<Icon> {
        return this._icons.asObservable();
    }

    // icons$: Observable<Icon>;
    filteredIcons$: Observable<Icon>;
    filterValue$: BehaviorSubject<string> = new BehaviorSubject('');

    private _unsubscribeAll: Subject<any> = new Subject();

    iconSets = [
        {value: 'davesa', viewValue: 'Davesa Icons'},
        {value: 'feather', viewValue: 'Feather Icons'},
        {value: 'heroicons-outline', viewValue: 'Hero Outline Icons'},
        {value: 'heroicons-solid', viewValue: 'Hero Solid Icons'},
        {value: 'heroicons-mini', viewValue: 'Hero Mini Icons'},
        {value: 'material-outline', viewValue: 'Material Outline Icons'},
        {value: 'material-solid', viewValue: 'Material Solid Icons'},
        {value: 'heroicons-twotone', viewValue: 'Material Twotone Icons'},
      ];
    /**
     * Constructor
     */
    constructor(private _iconsService: IconsService) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._iconsService.getIcons('davesa').pipe(take(1), switchMap((icons) => {

        // Get the icons
        return this._iconsService.icons$.pipe(switchMap((icons) => {
            this._icons.next(icons);
                    // Subscribe to icons
        return this._iconsService.icons$
        .pipe(takeUntil(this._unsubscribeAll), switchMap((icons) => {

            // Set the icon size in case the icon set
            // has a special base grid size
            this.iconSize = icons.grid;

            // Create filtered icons
            return this.filteredIcons$ = combineLatest([
                this.icons$,
                this.filterValue$,
            ]).pipe(
                map(([icons, filterValue]) => {
                    // Filter the icons
                    const filteredIcons = icons.list.filter((icon) =>
                        icon.toLowerCase().includes(filterValue.toLowerCase())
                    );

                    // Update the list with the filtered icons
                    return {
                        ...icons,
                        list: filteredIcons,
                    };
                })
            );
        }));


        }));

        })).subscribe();
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    filterItems(data: any) {
        console.log('filterItems', data.value)
        this._iconsService.getIcons(data.value).pipe(take(1), switchMap((icons) => {
            console.log('icons', icons)

            // Get the icons
            return this._iconsService.icons$.pipe(switchMap((icons) => {
                console.log('icons', icons)
                        // Subscribe to icons
            return this._iconsService.icons$
            .pipe(takeUntil(this._unsubscribeAll), switchMap((icons) => {
                console.log('icons', icons)

                // Set the icon size in case the icon set
                // has a special base grid size
                this.iconSize = icons.grid;
    
                // Create filtered icons
                return this.filteredIcons$ = combineLatest([
                    this.icons$,
                    this.filterValue$,
                ]).pipe(
                    map(([icons, filterValue]) => {
                        // Filter the icons
                        const filteredIcons = icons.list.filter((icon) =>
                            icon.toLowerCase().includes(filterValue.toLowerCase())
                        );
    
                        // Update the list with the filtered icons
                        return {
                            ...icons,
                            list: filteredIcons,
                        };
                    })
                );
            }));
    
    
            }));
    
            })).subscribe();
        }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Filter icons
     *
     * @param event
     */
    filterIcons(event: any): void {
        // Push the value to the observable
        this.filterValue$.next(event.target.value);
    }

    /**
     * Select an icon
     *
     * @param namespace
     * @param icon
     */
    pickIcon(namespace: string, icon: string): void {
        this.selectedIcon = [namespace, icon];
        this.iconPickerSelect.emit(this.selectedIcon);
    }

    /**
     * Returns the selected icon's svgIcon
     * to use in mat-icon component
     */
    calcSvgIconAttr(): string {
        if (!this.selectedIcon) {
            return '';
        }

        if (this.selectedIcon[0] === '') {
            return this.selectedIcon[1];
        }

        return this.selectedIcon.join(':');
    }

        /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
    
}


